"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Select } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import moment from "moment-jalaali";
import "moment/locale/fa";
import { JALALI_FIRST_DAY_OF_WEEK, JALALI_MONTHS, JALALI_WEEKDAYS_MIN, parseJalaliDate } from "@/app/utils/jalaliDate";
import { changeMonth, changeYear, createPanelState, selectDay, shiftMonth, syncToValue, type JalaliPanelTransition } from "@/app/components/Common/jalaliPanelState";
moment.loadPersian({
  usePersianDigits: false
});
moment.locale("fa");
type JalaliDatePanelProps = {
  value?: string;
  // `isComplete` is true once the user has picked the year, the month and the
  // day in this session, which is when the picker is allowed to close.
  onSelect: (value: string, isComplete: boolean) => void;
};
const JalaliDatePanel: React.FC<JalaliDatePanelProps> = t0 => {
  const $ = _c(66);
  const {
    value,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== value) {
    bb0: {
      const parsed = parseJalaliDate(value);
      if (!parsed) {
        t1 = null;
        break bb0;
      }
      t1 = {
        year: parsed.jYear(),
        month: parsed.jMonth(),
        day: parsed.jDate()
      };
    }
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedFromValue = t1;
  let t2;
  if ($[2] !== selectedFromValue) {
    t2 = () => createPanelState(selectedFromValue, {
      year: moment().jYear(),
      month: moment().jMonth()
    });
    $[2] = selectedFromValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [state, setState] = useState(t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = JALALI_MONTHS.map(_temp);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const months = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    const currentYear = moment().jYear();
    const start = currentYear - 100;
    const end = currentYear + 5;
    t4 = Array.from({
      length: end - start + 1
    }, (_, index_0) => start + index_0);
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const years = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = new Intl.NumberFormat("en-US", {
      useGrouping: false
    });
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const persianNumberNoGrouping = t5;
  let t6;
  let t7;
  if ($[7] !== selectedFromValue) {
    t6 = () => {
      setState(current => syncToValue(current, selectedFromValue));
    };
    t7 = [selectedFromValue];
    $[7] = selectedFromValue;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  useEffect(t6, t7);
  let t8;
  if ($[10] !== onSelect) {
    t8 = transition => {
      setState(transition.state);
      if (transition.commit) {
        onSelect(transition.commit.value, transition.commit.isComplete);
      }
    };
    $[10] = onSelect;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const apply = t8;
  const {
    view,
    selected
  } = state;
  let t9;
  if ($[12] !== view.month || $[13] !== view.year) {
    t9 = moment().jDate(1).jYear(view.year).jMonth(view.month);
    $[12] = view.month;
    $[13] = view.year;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const startOfMonth = t9;
  const leading = (startOfMonth.day() - JALALI_FIRST_DAY_OF_WEEK + 7) % 7;
  const daysInMonth = moment.jDaysInMonth(view.year, view.month);
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  if ($[15] !== apply || $[16] !== daysInMonth || $[17] !== leading || $[18] !== selected?.day || $[19] !== selected?.month || $[20] !== selected?.year || $[21] !== state || $[22] !== view.month || $[23] !== view.year) {
    const today = moment();
    const cells = [];
    for (let index_1 = 0; index_1 < leading; index_1 = index_1 + 1, index_1) {
      cells.push(null);
    }
    for (let day = 1; day <= daysInMonth; day = day + 1, day) {
      cells.push(day);
    }
    t12 = "w-[304px]";
    let t15;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <RightOutlined />;
      $[29] = t15;
    } else {
      t15 = $[29];
    }
    let t16;
    if ($[30] !== apply || $[31] !== state) {
      t16 = <Button type="text" size="small" icon={t15} onClick={() => apply(shiftMonth(state, -1))} />;
      $[30] = apply;
      $[31] = state;
      $[32] = t16;
    } else {
      t16 = $[32];
    }
    let t17;
    if ($[33] !== apply || $[34] !== state) {
      t17 = nextMonth => apply(changeMonth(state, nextMonth));
      $[33] = apply;
      $[34] = state;
      $[35] = t17;
    } else {
      t17 = $[35];
    }
    let t18;
    if ($[36] !== t17 || $[37] !== view.month) {
      t18 = <Select size="small" value={view.month} options={months} onChange={t17} className="min-w-[120px]" />;
      $[36] = t17;
      $[37] = view.month;
      $[38] = t18;
    } else {
      t18 = $[38];
    }
    const t19 = view.year;
    let t20;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = years.map(year => ({
        value: year,
        label: persianNumberNoGrouping.format(year)
      }));
      $[39] = t20;
    } else {
      t20 = $[39];
    }
    let t21;
    if ($[40] !== apply || $[41] !== state) {
      t21 = nextYear => apply(changeYear(state, nextYear));
      $[40] = apply;
      $[41] = state;
      $[42] = t21;
    } else {
      t21 = $[42];
    }
    let t22;
    if ($[43] !== t21 || $[44] !== view.year) {
      t22 = <Select size="small" value={t19} options={t20} onChange={t21} className="min-w-[100px]" />;
      $[43] = t21;
      $[44] = view.year;
      $[45] = t22;
    } else {
      t22 = $[45];
    }
    let t23;
    if ($[46] !== t18 || $[47] !== t22) {
      t23 = <div className="flex items-center gap-2">{t18}{t22}</div>;
      $[46] = t18;
      $[47] = t22;
      $[48] = t23;
    } else {
      t23 = $[48];
    }
    let t24;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = <LeftOutlined />;
      $[49] = t24;
    } else {
      t24 = $[49];
    }
    let t25;
    if ($[50] !== apply || $[51] !== state) {
      t25 = <Button type="text" size="small" icon={t24} onClick={() => apply(shiftMonth(state, 1))} />;
      $[50] = apply;
      $[51] = state;
      $[52] = t25;
    } else {
      t25 = $[52];
    }
    if ($[53] !== t16 || $[54] !== t23 || $[55] !== t25) {
      t13 = <div className="flex items-center justify-between gap-2 m-2">{t16}{t23}{t25}</div>;
      $[53] = t16;
      $[54] = t23;
      $[55] = t25;
      $[56] = t13;
    } else {
      t13 = $[56];
    }
    if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <div className="grid grid-cols-7 gap-1 text-center text-xs text-charcoal-600">{JALALI_WEEKDAYS_MIN.map(_temp2)}</div>;
      $[57] = t14;
    } else {
      t14 = $[57];
    }
    t10 = "grid grid-cols-7 gap-1 text-center text-sm mt-2";
    t11 = cells.map((day_1, index_2) => {
      if (!day_1) {
        return <div key={`empty-${index_2}`} />;
      }
      const isSelected = selected?.year === view.year && selected?.month === view.month && selected?.day === day_1;
      const isToday = today.jYear() === view.year && today.jMonth() === view.month && today.jDate() === day_1;
      const selectedClass = isSelected ? "bg-bluetiful-400 text-white" : "";
      const todayClass = !isSelected && isToday ? "border border-bluetiful-400 text-bluetiful-400" : "";
      return <button type="button" key={`day-${day_1}-${index_2}`} className={["h-8 w-8 rounded-full flex items-center justify-center cursor-pointer mx-auto", selectedClass, todayClass].filter(Boolean).join(" ")} onClick={() => apply(selectDay(state, day_1))}>{day_1.toLocaleString("en-US")}</button>;
    });
    $[15] = apply;
    $[16] = daysInMonth;
    $[17] = leading;
    $[18] = selected?.day;
    $[19] = selected?.month;
    $[20] = selected?.year;
    $[21] = state;
    $[22] = view.month;
    $[23] = view.year;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t10 = $[24];
    t11 = $[25];
    t12 = $[26];
    t13 = $[27];
    t14 = $[28];
  }
  let t15;
  if ($[58] !== t10 || $[59] !== t11) {
    t15 = <div className={t10}>{t11}</div>;
    $[58] = t10;
    $[59] = t11;
    $[60] = t15;
  } else {
    t15 = $[60];
  }
  let t16;
  if ($[61] !== t12 || $[62] !== t13 || $[63] !== t14 || $[64] !== t15) {
    t16 = <div className={t12}>{t13}{t14}{t15}</div>;
    $[61] = t12;
    $[62] = t13;
    $[63] = t14;
    $[64] = t15;
    $[65] = t16;
  } else {
    t16 = $[65];
  }
  return t16;
};
export default JalaliDatePanel;
function _temp(label, index) {
  return {
    value: index,
    label
  };
}
function _temp2(day_0) {
  return <div key={day_0}>{day_0}</div>;
}